import EnterOTP from "./EnterOTP";

export default EnterOTP;
